import { Pipe, PipeTransform } from '@angular/core';
import * as urljoin from 'url-join';

const pathname = window.location.pathname;

@Pipe({
  name: 'relativeUrl'
})
export class RelativeUrlPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    // const baseHref = (document.getElementsByTagName('base')[0] || {}).href;
    return urljoin(pathname, value);
  }

}
